import type { Task } from '../models/Task';
export function compareClientWork(a: Task, b: Task) {
  const rank = (task: Task) => task.clientDecision?.disposition === 'requested'
    ? ({ high: 0, medium: 1, low: 2 }[task.clientDecision.priority] ?? 1)
    : task.clientDecision?.disposition === 'deferred' ? 4 : 3;
  return rank(a) - rank(b);
}
